import { connect } from 'react-redux';
import { Box } from 'components/common/box';
import { Alert, ApiDownloadButton } from 'components/common';

export default connect((state) => state)(
  ({ messages, pageState: { user } }) => (
    <div className="data">
      <Box title={messages.profileUserData}>
        <Alert text={messages.profileUserDataInfo} />

        <div className="download">
          <ApiDownloadButton
            filename={`${user.email || user.username}.json`}
            icon="file-download"
            text={messages.profileUserDataDownload}
            url="/auth/profile/data"
          />
        </div>
      </Box>

      <style jsx>{`
        .download {
          margin-top: 15px;
        }
      `}</style>
    </div>
  )
);
